"use client";
import { EmbedIcon, EmbedIconProps } from "@zapier/chatbots-tailwind";
import { Icon } from "@zapier/zinnia-icons";
import { useEffect } from "react";
import { cn } from "utils/cn";

type Embed = Pick<
  EmbedIconProps,
  "iconUrl" | "iconMask" | "iconSize" | "openByDefault"
>;

type Props = {
  isHidden: boolean;
  onClickToggleHandler: () => void;
  embed: Embed;
};

export default function ChatbotTailwindEmbedIcon({
  isHidden,
  onClickToggleHandler,
  embed,
}: Props) {
  useEffect(() => {
    window.parent.postMessage("zChatbotReady", "*");
  }, []);

  return (
    <EmbedIcon
      {...embed}
      cn={cn}
      closeIconSlot={() => (
        <>
          <Icon
            color="currentColor"
            name="formX"
            size={embed.iconSize - 20}
            aria-hidden
          />
          <span className="sr-only">Close Chatbot</span>
        </>
      )}
      openIconSlot={() => (
        <>
          <Icon
            color="currentColor"
            name="navAIChatbot"
            size={embed.iconSize - 20}
            aria-hidden
          />
          <span className="sr-only">Open Chatbot</span>
        </>
      )}
      isHidden={isHidden}
      onClick={onClickToggleHandler}
    />
  );
}
